import Tag from './Tag'
import styles from './TagDouble.module.scss'
import type { TagDoubleProps } from './types'
import { TagStyle, TagVariant } from './types'

const TagDouble: React.FC<TagDoubleProps> = ({
  leadingIcon,
  leadingText,
  trailingIcon,
  rtl,
  trailingText,
  style,
}) => {
  return (
    <div className={styles['pintxo-tag-double']}>
      <Tag
        style={style}
        variant={TagVariant.primary}
        label={leadingText}
        leadingIcon={leadingIcon}
        rtl={rtl}
        className={styles['pintxo-tag-double-leading']}
      />
      <Tag
        leadingIcon={trailingIcon}
        label={trailingText}
        style={TagStyle.contrast}
        rtl={rtl}
        className={styles['pintxo-tag-double-trailing']}
      />
    </div>
  )
}

export default TagDouble
